import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from '@/router/routers'
Vue.use(VueRouter)

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const routes = routers

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // 访客页路径存放列表
  const guestPages = [
    '/productload',
    '/selectProduct'
  ]
  if (guestPages.includes(to.path)) {
    const isRouteTo = to.query.isPushed ? to.query.isPushed : false
    const productId = to.query.productId
    // 若在产品选择页进行的跳转则直接放行
    if (to.path === '/productload' && isRouteTo) {
      return next()
    }
    // 没有在产品选择页进行的需要判断是否为 TI Stdio 产品 判断依据为产品 id 加密后的字符串
    if (to.path === '/productload' && productId === 'Im0QFpsT6rVrpX36zh1vh3BHAwT3V6WBasgMD6D/gQA=') {
      next('/selectProduct?productId=' + encodeURIComponent(productId))
    }
    next()
  } else {
    if (Vue.cookie.get('token')) { // 有token
      if (to.path === '/login') { // 无需再次登录，跳转首页
        next('/')
      } else {
        sessionStorage.setItem('current_menu_path', to.path) // 记录目标页path
        next()
      }
    } else { // 无token, 跳登录页
      if (to.path === '/login') { // 避免重复触发
        next()
      } else {
        next('/login')
      }
    }
  }
})

export default router
